'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deletePost = exports.createPost = exports.fetchPosts = exports.deserializePost = undefined;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _oembed = require('constructicon/lib/oembed');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getMedia = function getMedia(post, filterMethod) {
  return (0, _get2.default)((0, _get2.default)(post, 'media', []).filter(filterMethod), '[0].url');
};

var deserializePost = exports.deserializePost = function deserializePost(post) {
  return {
    id: post.id,
    createdAt: post.createdAt,
    message: post.message,
    media: post.media,
    image: getMedia(post, function (media) {
      return media.__typename === 'ImageMedia' && !_oembed.videoRegex.test(media.url);
    }),
    type: post.type,
    video: getMedia(post, function (media) {
      return media.__typename === 'VideoMedia';
    }) || getMedia(post, function (media) {
      return _oembed.videoRegex.test(media.url);
    })
  };
};

var fetchPosts = exports.fetchPosts = function fetchPosts(_ref) {
  var _ref$slug = _ref.slug,
      slug = _ref$slug === undefined ? (0, _params.required)() : _ref$slug,
      _ref$allPosts = _ref.allPosts,
      allPosts = _ref$allPosts === undefined ? false : _ref$allPosts,
      after = _ref.after,
      _ref$results = _ref.results,
      results = _ref$results === undefined ? [] : _ref$results,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'FUNDRAISING' : _ref$type;

  var query = '\n    {\n      page(type: ' + type + ', slug: "' + slug + '") {\n        timeline(first: 20' + (after ? ', after: "' + after + '"' : '') + ') {\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n          nodes {\n            id\n            legacyId\n            message\n            type\n            createdAt\n            fitnessActivity { activityType }\n            media {\n              __typename\n              ... on ImageMedia { url caption }\n              ... on VideoMedia { url }\n            }\n          }\n        }\n      }\n    }\n  ';

  return _client.servicesAPI.post('/v1/justgiving/graphql', { query: query }).then(function (response) {
    return response.data;
  }).then(function (result) {
    var data = (0, _get2.default)(result, 'data.page.timeline', {});
    var _data$pageInfo = data.pageInfo,
        pageInfo = _data$pageInfo === undefined ? {} : _data$pageInfo,
        _data$nodes = data.nodes,
        nodes = _data$nodes === undefined ? [] : _data$nodes;

    var updatedResults = [].concat(_toConsumableArray(results), _toConsumableArray(nodes));

    if (allPosts && pageInfo.hasNextPage) {
      return fetchPosts({
        slug: slug,
        after: pageInfo.endCursor,
        results: updatedResults,
        allPosts: true
      });
    } else {
      return updatedResults.filter(function (post) {
        return !post.fitnessActivity;
      });
    }
  });
};

var createPost = exports.createPost = function createPost(_ref2) {
  var _ref2$pageId = _ref2.pageId,
      pageId = _ref2$pageId === undefined ? (0, _params.required)() : _ref2$pageId,
      _ref2$userId = _ref2.userId,
      userId = _ref2$userId === undefined ? (0, _params.required)() : _ref2$userId,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token,
      image = _ref2.image,
      message = _ref2.message,
      video = _ref2.video;

  var headers = {
    Authorization: 'Bearer ' + token
  };

  var imageMedia = image ? 'imageMedia: { url: "' + image + '" }' : '';
  var videoMedia = video ? 'videoMedia: { url: "' + video + '" }' : '';
  var media = image || video ? 'media: { ' + imageMedia + ' ' + videoMedia + ' }' : '';

  var query = '\n    mutation {\n      createTimelineEntry (\n        input: {\n          type: FUNDRAISING\n          pageId: "' + pageId + '"\n          creatorGuid: "' + userId + '"\n          message: "' + message + '"\n          ' + media + '\n        }\n      ) {\n        id\n        message\n        createdAt\n        media {\n          __typename\n          ... on ImageMedia { url }\n          ... on VideoMedia { url }\n        }\n      }\n    }\n  ';

  return _client.servicesAPI.post('/v1/justgiving/graphql', { query: query }, { headers: headers }).then(function (response) {
    return response.data;
  }).then(function (result) {
    return (0, _get2.default)(result, 'data.createTimelineEntry');
  });
};

var deletePost = exports.deletePost = function deletePost(_ref3) {
  var _ref3$id = _ref3.id,
      id = _ref3$id === undefined ? (0, _params.required)() : _ref3$id,
      _ref3$token = _ref3.token,
      token = _ref3$token === undefined ? (0, _params.required)() : _ref3$token;

  var query = '\n    mutation {\n      deleteTimelineEntry (\n        input: {\n          id: "' + id + '"\n        }\n      )\n    }\n  ';

  var headers = { Authorization: 'Bearer ' + token };

  return _client.servicesAPI.post('/v1/justgiving/graphql', { query: query }, { headers: headers }).then(function (response) {
    return response.data;
  }).then(function (result) {
    return (0, _get2.default)(result, 'data.deleteTimelineEntry');
  });
};